export default __webpack_public_path__ + "static/media/logo-vodafone.1e52b2a1.svg";